import axios from 'axios';
import Events from '@/app/events.js'

axios.defaults.withCredentials = true;

const PROCESSER_API = process.env.VUE_APP_API_URL;

const state = {
	processes:[],
}

const actions = {

   /**
   	* Delete a process runner
   	* 
   	* @param {State} State
   	* @param {Commit} commit 
   	* @param {Object} payload 
   	* 
   	* @return { Promise }
   	*/
 	deleteProcess({commit,state},payload) {

		return new Promise((resolve, reject) => {

			return axios.delete(`${PROCESSER_API}/process/${payload.pm_id}`).then( response => {
				resolve(response);
			}).catch( error => reject(error))

	    });

  	},

   /** 
   	* get list of active process runners
   	* 
   	* @param {State} State
   	* @param {Commit} commit 
   	* @param {Object} payload 
   	* 
   	* @return { Promise }
   	*/
 	getProcesses({commit,state}) {

		return new Promise((resolve, reject) => {
			return axios.get(`${PROCESSER_API}/process`).then( response => {

				resolve(response.data.data);
				commit('setProcesses',response.data.data);
				

			}).catch( error => reject(error))
	    });

  	},

   /**
   	* get list of active process runners
   	* 
   	* @param {State} State
   	* @param {Commit} commit 
   	* @param {Object} payload 
   	* 
   	* @return { Promise }
   	*/
 	startProcesses({commit,state}) {

		return new Promise((resolve, reject) => {
			return axios.post(`${PROCESSER_API}/process/default`).then( response => {
				resolve(response.data);
			}).catch( error => reject(error))
	    });

  	},

   /**
   	* create new short liveed process
   	* 
   	* @param {State} State
   	* @param {Commit} commit 
   	* @param {Object} payload 
   	* 
   	* @return { Promise }
   	*/
 	createProcess({commit,state},payload) {

		return new Promise((resolve, reject) => {

			return axios.post(`${PROCESSER_API}/process/launch`, payload).then( response => {

				commit('setProcess',response.data.data[0])
				resolve(response.data);

			}).catch( error => reject(error))

	    });

  	},

}

const mutations = {


   /**
   	* set processes list
   	*
   	* @param {Object} state 
   	* @param {Object} payload 
   	*/
  	setProcesses(state, payload) {
  		return state.processes = payload
  	},

	/**
   	 * set single process
   	 *
   	 * @param {Object} state 
   	 * @param {Object} payload 
   	 */
  	setProcess(state, payload) {
  		return state.processes.push(payload)
  	},


}

const getters = {

}

export default {
  state,
  mutations,
  actions,
  getters
}